export default defineNuxtPlugin((nuxtApp) => {
  if (typeof window !== 'undefined' && typeof Worker !== 'undefined') {
    import('heic2any').then(({ default: heic2any }) => {
      async function heicToAny(
        file: File,
      ): Promise<{ base64: Blob | BlobPart[]; file: File }> {
        if (!heic2any) throw new Error('heic2any is not available');

        const base64 = await heic2any({ blob: file, toType: 'image/jpeg' });
        return {
          file: new File(
            Array.isArray(base64) ? base64 : [base64],
            `${file.name.split('.')[0]}.jpeg`,
            { type: 'image/jpeg' },
          ),
          base64,
        };
      }

      nuxtApp.provide('heicToAny', heicToAny);
    });
  }
});
